export default __webpack_public_path__ + "static/love-ebbe8c36e854e86c1d46ac916672616e.png";